import { useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import logo from "../assets/logo.png";
import down from "../assets/Down.svg";
import icon from "../assets/Icon.png";
import hr from "../assets/Hr.png";
import tick from "../assets/Tick.png";
import meet from "../assets/Meet.png";
import as from "../assets/As.png";
import ga from "../assets/Ga.png";
import dock from "../assets/Do.png";
import twit from "../assets/Twit.png";
import sig from "../assets/Sig.png";
import veh from "../assets/Veh.png";
import trans from "../assets/Trans.png";
import vec from "../assets/Vec.svg";
import successIcon from "../assets/success.png";
import errorIcon from "../assets/error.png";
import o1 from "../assets/O1.png";
import o2 from "../assets/O2.png";
import o3 from "../assets/O3.png";
import o4 from "../assets/O4.png";
import o5 from "../assets/O5.png";
import news from "../assets/News.png";
import mail from "../assets/Mail.png";
import insta from "../assets/Insta.png";
import face from "../assets/Facebook.png";
import youtube from "../assets/Youtube.png";
import link from "../assets/Link.png";
import riarr from "../assets/Rightarr.svg";
import phone from "../assets/Phone.png";
import email from "../assets/Email.png";
import trial from "../assets/Trial.png";


import nr from "../assets/Nr.png";
import bus from "../assets/Bus.png";
import q from "../assets/Q.png";
import tg from "../assets/Tick.png";
import n from "../assets/N.png";
import right from "../assets/Right.svg";
import asset from "../assets/Asset.svg";
import gate from "../assets/Gate.svg";
import sign from "../assets/Sign.svg";
const Pricing = () => {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

useEffect(() => {
  const handleResize = () => setScreenWidth(window.innerWidth);
  window.addEventListener("resize", handleResize);
  return () => window.removeEventListener("resize", handleResize);
}, []);
  const navigate = useNavigate();
  const [activeItem, setActiveItem] = useState("Pricing");
  const [showDropdown, setShowDropdown] = useState(false);
  const policyRoutes = {
    "Terms and Conditions": "/terms",
    "Privacy Policy": "/privacy",
    "Cookie Policy": "/cookies",
    "Copyright Policy": "/copyright",
  };

    const dropdownItems = [
      {
        title: "LOGISTICS OPERATIONS",
        items: [
          {
            icon: gate,
            name: "Gate",
            description: "Helps organizations track and manage visitors efficiently.",
          },
          {
            icon: dock,
            name: "Dock",
            description: "Helps businesses streamline loading, unloading & scheduling.",
          },
          {
            icon: sign,
            name: "Signage",
            description: "Creating, managing & displaying digital content on screens.",
          },
        ],
      },
      {
        title: "TRACKING SYSTEM",
        items: [
          {
            icon: trans,
            name: "Transport",
            description: "Helps users efficiently manage & optimize transportation services.",
          },
          {
            icon: bus,
            name: "Vehicle Management",
            description: "Tracks vehicles, optimizes routes, and automates expenses.",
          },
          {
            icon: asset,
            name: "Asset",
            description: "Helps businesses track, monitor, and manage assets efficiently.",
          },
        ],
      },
      {
        title: "WORKFORCE MANAGEMENT",
        items: [
          {
            icon: q,
            name: "MeetQ",
            description: "Book & manage meeting rooms with real-time tracking.",
          },
          {
            icon: tg,
            name: "TickGo",
            description: "Track tasks, log hours, and update statuses.",
          },
          {
            icon: n,
            name: "Nexus",
            description: "Manage attendance, tasks, and productivity.",
          },
        ],
      },
    ];

    const handleClick = (item) => {
      setActiveItem(item);
  
      if (item === "Products") {
        setShowDropdown(!showDropdown);
      } else {
        setShowDropdown(false);
      }
  
      if (item === "Pricing") {
        navigate("/new");
      }
  
      if (item === "Home") {
        navigate("/");
      }
  
      if (item === "Say Hello") {
        navigate("/contact"); // Change this to the actual route for the "Say Hello" page
      }
      if (item === "Partner") {
        navigate("/part"); 
      }
    };
  const [activePlan, setActivePlan] = useState("Monthly");
  const products = [
    { name: "TickGo", imgSrc: tick, activeColor: "#004BA8" },
    { name: "HR Nexus", imgSrc: hr, activeColor: "#004BA8" },
    { name: "MeetQ", imgSrc: meet, activeColor: "#004BA8" },
    { name: "Asset", imgSrc: as, activeColor: "#004BA8" },
    { name: "Gate", imgSrc: ga, activeColor: "#004BA8" },
    { name: "Dock", imgSrc: dock, activeColor: "#004BA8" },
    { name: "Signage", imgSrc: sig, activeColor: "#004BA8" },
    { name: "Vehicle", imgSrc: veh, activeColor: "#004BA8" },
    { name: "Transport", imgSrc: trans, activeColor: "#004BA8" },
  ];
  const [selected, setSelected] = useState("TickGo");
  const features = [
    { text: "Dashboard Access", included: true },
    { text: "All Basic Features", included: true },
    { text: "Role-based Permissions", included: true },
    { text: "All Pro Features", included: false },
    { text: "Standard Report", included: false },
    { text: "Standard Report", included: false },
    { text: "8 Days Free Trial", included: true },
  ];
  const complianceData = [
    { icon: o1, title: "General Data Protection" },
    { icon: o2, title: "SOC2 Compliance Report" },
    { icon: o3, title: "Data Processing Agreement" },
    { icon: o4, title: "ISO Certification" },
    { icon: o5, title: "VAPT Compliance" },
  ];

  return (
    <div>
   <div
  style={{
    position: "fixed",
    bottom: "40px",
    right: "20px",
    zIndex: 20,
  }}
>
  <button
    style={{
      padding: 0,
      background: "transparent",
      border: "none",
      cursor: "pointer",
      outline: "none",
      transition: "transform 0.3s ease, box-shadow 0.3s ease",
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.transform = "scale(1.1)";
      e.currentTarget.style.boxShadow = "0 8px 20px rgba(0, 123, 255, 0.4)";
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.transform = "scale(1)";
      e.currentTarget.style.boxShadow = "none";
    }}
    aria-label="Scroll to top" // or whatever action this button performs
  >
    <img
      src={icon}
      alt="button icon"
      style={{
        width: "55px",
        height: "55px",
        animation: "pulse 2s infinite ease-in-out",
      }}
    />
  </button>

  {/* Add this CSS in your global styles */}
  <style>
    {`
      @keyframes pulse {
        0%, 100% {
          transform: scale(1);
        }
        50% {
          transform: scale(1.08);
        }
      }
    `}
  </style>
</div>

      

      {/* Navigation Bar */}
      <div style={{ width: "100%" }}>
             <div
          style={{
            fontFamily: "Epilogue",
            lineHeight: "1.4",
            position: "sticky", // Keeps it at the top during scroll
            top: "0",
            zIndex: 1000,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "10px 5%",
            backgroundColor: "#fff",
            flexWrap: "wrap",
            boxShadow: "0 2px 6px rgba(0,0,0,0.05)", // Optional for scroll shadow
          }}
        >
          <img
            src={logo}
            alt="Logo"
            style={{ maxWidth: "150px", height: "auto", marginLeft: "-50px" }}
          />
        
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              flexWrap: "wrap",
            }}
          >
            {["Home", "Products", "Pricing", "Partner", "Say Hello"].map(
              (item, index) => (
                <div key={index} style={{ position: "relative" }}>
                  <div
                    onClick={() => handleClick(item)}
                    style={{
                      fontSize: "clamp(12px, 2vw, 16px)",
                      cursor: "pointer",
                      fontWeight: "normal",
                      backgroundColor: activeItem === item ? "#EAF3FF" : "transparent",
                      padding: "8px 16px",
                      borderRadius: "20px",
                      transition: "background-color 0.3s",
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                    }}
                  >
                    {item}
        
                    {item === "Products" && (
                      <img
                        src={down}
                        alt="Down Arrow"
                        style={{
                          width: "10px",
                          height: "7px",
                          transform: showDropdown
                            ? "rotate(180deg)"
                            : "rotate(0deg)",
                        }}
                      />
                    )}
                  </div>
        
                  {item === "Products" && showDropdown && (
                    <div
                      style={{
                        position: "absolute",
                        top: "40px",
                        left: "0",
                        marginLeft: "-400px",
                        backgroundColor: "#FFFFFF",
                        boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                        borderRadius: "24px",
                        overflow: "hidden",
                        zIndex: 10,
                        width: "980px",
                        padding: "24px",
                        display: "grid",
                        gridTemplateColumns: "repeat(3, 1fr)",
                        gap: "32px",
                      }}
                    >
                      {dropdownItems.map((section, i) => (
                        <div
                          key={i}
                          style={{
                            paddingRight:
                              i < dropdownItems.length - 1 ? "32px" : "0",
                            borderRight:
                              i < dropdownItems.length - 1
                                ? "1px solid #E0E0E0"
                                : "none",
                          }}
                        >
                          <div
                            style={{
                              color: "#666",
                              fontWeight: "600",
                              marginBottom: "16px",
                              textTransform: "uppercase",
                              fontSize: "13px",
                            }}
                          >
                            {section.title}
                          </div>
                          {section.items.map((product, j) => (
                            <div
                              key={j}
                              style={{
                                display: "flex",
                                alignItems: "flex-start",
                                gap: "12px",
                                padding: "8px 0",
                                cursor: "pointer",
                                marginBottom: "12px",
                                borderRadius: "8px",
                                transition: "background-color 0.3s ease",
                              }}
                              onClick={() => {
                                if (product.name === "Gate") {
                                  navigate("/gate"); 
                                }   else if (product.name === "MeetQ") {
                                  navigate("/meetq");
                                }
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor = "#F0F8FF";
                                const name =
                                  e.currentTarget.querySelector(".product-name");
                                const arrow =
                                  e.currentTarget.querySelector(".arrow-icon");
                                name.style.color = "#004aad";
                                arrow.style.filter =
                                  "brightness(0) saturate(100%) invert(17%) sepia(99%) saturate(746%) hue-rotate(197deg) brightness(94%) contrast(100%)";
                                arrow.style.transform = "translateX(4px)";
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = "transparent";
                                const name =
                                  e.currentTarget.querySelector(".product-name");
                                const arrow =
                                  e.currentTarget.querySelector(".arrow-icon");
                                name.style.color = "inherit";
                                arrow.style.filter = "none";
                                arrow.style.transform = "translateX(0)";
                              }}
                            >
                              <img
                                src={product.icon}
                                alt={product.name}
                                style={{ width: "25px", height: "25px" }}
                              />
                              <div>
                                <div
                                  className="product-name"
                                  style={{
                                    fontWeight: "600",
                                    display: "flex",
                                    alignItems: "center",
                                    transition: "color 0.3s ease",
                                  }}
                                >
                                  {product.name}
                                  <img
                                    className="arrow-icon"
                                    src={nr}
                                    alt="arrow"
                                    style={{
                                      marginLeft: "4px",
                                      width: "20px",
                                      height: "20px",
                                      transition:
                                        "filter 0.3s ease, transform 0.3s ease",
                                    }}
                                  />
                                </div>
                                <div
                                  style={{
                                    color: "#666",
                                    fontSize: "14px",
                                    textAlign: "left",
                                    lineHeight: "1.4",
                                  }}
                                >
                                  {product.description}
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      ))}
        
                      {/* Explore all products */}
                      <div
                        style={{
                          gridColumn: "1 / -1",
                          textAlign: "right",
                          marginTop: "12px",
                        }}
                      >
                        <a
                          href="#"
                          style={{
                            color: "#004aad",
                            fontWeight: "600",
                            fontSize: "16px",
                            textDecoration: "none",
                          }}
                        >
                          Explore all products
                          <img
                            src={right}
                            alt="arrow"
                            style={{
                              marginLeft: "4px",
                              width: "16px",
                              height: "16px",
                              verticalAlign: "middle",
                            }}
                          />
                        </a>
                      </div>
                    </div>
                  )}
                </div>
              )
            )}
        
            <div style={{ display: "flex", justifyContent: "end", gap: "8px" }}>
              <button
                style={{
                  padding: "10px 20px",
                  borderRadius: "20px",
                  border: "1px solid #004aad",
                  backgroundColor: "#fff",
                  color: "#004aad",
                  fontWeight: "bold",
                  cursor: "pointer",
                }}
              >
                Login
              </button>
              <button
                style={{
                  padding: "10px 20px",
                  borderRadius: "20px",
                  border: "none",
                  backgroundColor: "#004aad",
                  color: "#fff",
                  fontWeight: "bold",
                  cursor: "pointer",
                }}
              >
                Register
              </button>
            </div>
          </div>
        </div>
        <div
  style={{
    backgroundColor: "#F7F8FA",
    minHeight: "100vh",
    padding: "40px 5vw",
  }}
>

          <div
  style={{
    fontFamily: "Epilogue",
            lineHeight: "1.4",
    backgroundColor: "#F7F8FA",
    padding: "40px 20px", // reduced horizontal padding for smaller screens
  }}
>
  <div
    style={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      maxWidth: "1200px", // limits width on large screens
      margin: "0 auto", // centers the content
      flexWrap: "wrap", // allows wrapping on small screens
      gap: "20px", // adds spacing when it wraps
    }}
  >
    <div>
      <div
        style={{
          fontSize: "28px",
          fontWeight: "bold",
          color: "#232323",
          marginLeft:"70px",
          margin: "0",
        }}
      >
        Choose the Perfect Plan for Your Business
      </div>
      <div
        style={{ color: "#6B7280", fontSize: "16px", marginTop: "8px" ,marginLeft:"5px",}}
      >
        Flexible plans tailored to your business needs
      </div>
    </div>

    <div
      style={{
        marginRight:"30px",
        display: "flex",
        backgroundColor: "#FFFFFF",
        borderRadius: "999px",
        padding: "4px",
        boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)",
      }}
    >
      <div
        onClick={() => setActivePlan("Monthly")}
        style={{
          padding: "10px 20px",
          borderRadius: "999px",
          fontWeight: "bold",
          fontSize: "14px",
          cursor: "pointer",
          backgroundColor:
            activePlan === "Monthly" ? "#004AAD" : "transparent",
          color: activePlan === "Monthly" ? "#FFFFFF" : "#6B7280",
          transition: "0.3s",
        }}
      >
        Monthly
      </div>

      <div
        onClick={() => setActivePlan("Annually")}
        style={{
          padding: "10px 20px",
          borderRadius: "999px",
          fontWeight: "bold",
          fontSize: "14px",
          cursor: "pointer",
          backgroundColor:
            activePlan === "Annually" ? "#004AAD" : "transparent",
          color: activePlan === "Annually" ? "#FFFFFF" : "#6B7280",
          transition: "0.3s",
        }}
      >
        Annually
      </div>
    </div>
  </div>
</div>

          <div
  style={{
    fontFamily: "Epilogue",
            lineHeight: "1.4",
    backgroundColor: "#fff",
    padding: screenWidth >= 1440 ? "20px 40px" : "15px 50px",
    borderRadius: "32px",
    width: "100%",
    maxWidth: screenWidth >= 1440 ? "1000px" : "90%",
    margin: "auto",
    overflow: "hidden",
  }}
>
<h2 style={{ fontSize: "20px", marginLeft: "-30px" }}>Mawalog suite</h2>

  <p
    style={{
      color: "#6B7280",
      fontSize: "14px",
      marginLeft: "-30px",
     
    }}
  >
    Select the product
  </p>

  <div
  style={{
    fontFamily: "Epilogue",
    lineHeight: "1.4",
    display: "flex",
    gap: "10px",
    overflowX: "auto", // enable horizontal scrolling
    whiteSpace: "nowrap", // prevent wrapping
    padding: "10px 0",
    scrollbarWidth: "none", // hide scrollbar in Firefox
    msOverflowStyle: "none", // hide scrollbar in IE/Edge
    marginLeft: "-35px",
  }}
  className="scroll-container" // for custom scrollbar hiding
>
  {products.map((product) => (
    <div
      key={product.name}
      onClick={() => setSelected(product.name)}
      style={{
        display: "inline-flex", // use inline-flex for nowrap behavior
        alignItems: "center",
        padding: "6px 12px",
        borderRadius: "50px",
        cursor: "pointer",
        backgroundColor:
          selected === product.name ? product.activeColor : "#F3F4F6",
        color: selected === product.name ? "#FFFFFF" : "#232323",
        fontWeight: selected === product.name ? "bold" : "normal",
        transition: "0.3s",
        flexShrink: 0, // prevent items from shrinking
      }}
    >
      <img
        src={product.imgSrc}
        alt={product.name}
        style={{
          width: "20px",
          height: "20px",
          marginRight: "5px",
        }}
      />
      {product.name}
    </div>
  ))}
  <style>
    {`
      .scroll-container::-webkit-scrollbar {
        display: none; /* hide scrollbar in Chrome, Safari */
      }
    `}
  </style>
</div>

</div>

<div
  style={{
        fontFamily: "Epilogue",
            lineHeight: "1.4",
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    gap: "30px",
    marginTop: "20px",
  }}
>
  {[16, 24, 48].map((price, index) => (
    <div
      key={index}
      style={{
        backgroundColor: "#fff",
        borderRadius: "20px",
        padding: "20px",
        width: "300px",
        fontFamily: "Arial, sans-serif",
        position: "relative",
        overflow: "hidden",
        boxShadow: "0 0 10px rgba(0,0,0,0.05)",
      }}
    >
      <img
        src={vec}
        alt="vector"
        style={{
          position: "absolute",
          top: "-5px",
          right: "-15px",
          width: "230px",
          height: "230px",
        }}
      />

      <h3 style={{ fontSize: "18px", marginBottom: "10px" }}>Basic</h3>
      <p style={{ fontSize: "40px", fontWeight: "bold", margin: "0" }}>
        {price}
        <span style={{ fontSize: "40px" }}>$</span>{" "}
        <span style={{ fontSize: "14px", fontWeight: "normal" }}>
          per month
        </span>
      </p>

      <div
        style={{
          color: "#616161",
          fontSize: "14px",
          textAlign: "start",
          margin: "10px 0 15px",
        }}
      >
        Perfect for small teams and startups <br />
        to get started with essential features.
      </div>

      <button
        style={{
          width: "100%",
          padding: "10px",
          borderRadius: "10px",
          backgroundColor: "white",
          color: "#006AEA",
          fontWeight: "bold",
          cursor: "pointer",
          fontSize: "14px",
          transition: "all 0.3s ease",
          borderTop: "1px solid #006AEA",
          borderLeft: "1px solid #006AEA",
          borderRight: "3px solid #006AEA",
          borderBottom: "3px solid #006AEA",
        }}
        onMouseEnter={(e) => {
          e.target.style.backgroundColor = "#F0F7FF";
          e.target.style.border = "none";
        }}
        onMouseLeave={(e) => {
          e.target.style.backgroundColor = "white";
          e.target.style.borderTop = "1px solid #006AEA";
          e.target.style.borderLeft = "1px solid #006AEA";
          e.target.style.borderRight = "3px solid #006AEA";
          e.target.style.borderBottom = "3px solid #006AEA";
        }}
      >
        {price === 48 ? "Reach Out" : "Get Started"}
      </button>

      <ul style={{ listStyle: "none", padding: "0" }}>
        {features.map((feature, idx) => (
          <li
            key={idx}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
              fontSize: "14px",
              marginBottom: "12px",
            }}
          >
            <img
              src={feature.included ? successIcon : errorIcon}
              alt={feature.included ? "Included" : "Not Included"}
              style={{ width: "20px", height: "20px" }}
            />
            {feature.text}
          </li>
        ))}
      </ul>
    </div>
  ))}
</div>

        </div>

        <div
          style={{
            fontFamily: "Epilogue",
            lineHeight: "1.4",
            padding: "60px",
            marginTop: screenWidth <= 1024 ? "40px" : "0",
          }}
        >
          <div
            style={{
              maxWidth: "1200px",
              margin: "0 auto", // center the container
            }}
          >
            {/* First Row Container with Title */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              {/* Title */}
              <div
          style={{
            fontFamily: "Epilogue",
            lineHeight: "1.4",
            color: "#181835",
            fontSize: "22px",
            fontWeight: "bold",
            paddingLeft: screenWidth <= 1440 ? "110px" : "170px", // Responsive left padding
            alignSelf: "flex-start", // Align text to left within flex
          }}
        >
          Compliance of our company
        </div>
        
        
              {/* First Row with 3 Items */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "15px",
                  marginTop: "20px",
                  flexWrap: "wrap",
                }}
              >
                {complianceData.slice(0, 3).map((item, index) => (
                  <div
                    key={index}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      backgroundColor: "#F4F7FF",
                      width: "270px",
                      height: "40px",
                      padding: "5px",
                      borderRadius: "30px",
                      justifyContent: "space-between",
                      cursor: "pointer",
                      transition: "background-color 0.3s, transform 0.3s ease",
                      marginBottom: screenWidth <= 1024 ? "15px" : "0",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = "#EDF4FF";
                      e.currentTarget.style.transform = "scale(1.03)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = "#F4F7FF";
                      e.currentTarget.style.transform = "scale(1)";
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <div
                        style={{
                          borderRadius: "50%",
                          padding: "10px",
                          marginRight: "12px",
                        }}
                      >
                        <img
                          src={item.icon}
                          alt={item.title}
                          style={{ width: "40px", height: "40px" }}
                        />
                      </div>
                      <span
                        style={{
                          color: "#181835",
                          fontSize: "12px",
                          marginRight: "-10px",
                        }}
                      >
                        {item.title}
                      </span>
                    </div>
                    <img
                      src={riarr}
                      alt="Arrow"
                      style={{ width: "18px", height: "18px" }}
                    />
                  </div>
                ))}
              </div>
            </div>
        
            {/* Second Row */}
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "15px",
                marginTop: "20px",
                flexWrap: "wrap",
                marginRight: screenWidth <= 1024 ? "10px" : "290px",
              }}
            >
              {complianceData.slice(3, 5).map((item, index) => (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    backgroundColor: "#F4F7FF",
                    width: "270px",
                    height: "40px",
                    padding: "5px",
                    borderRadius: "30px",
                    justifyContent: "space-between",
                    cursor: "pointer",
                    transition: "background-color 0.3s, transform 0.3s ease",
                    marginBottom: screenWidth <= 1024 ? "15px" : "0",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#EDF4FF";
                    e.currentTarget.style.transform = "scale(1.03)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "#F4F7FF";
                    e.currentTarget.style.transform = "scale(1)";
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div
                      style={{
                        borderRadius: "50%",
                        padding: "10px",
                        marginRight: "12px",
                      }}
                    >
                      <img
                        src={item.icon}
                        alt={item.title}
                        style={{ width: "40px", height: "40px" }}
                      />
                    </div>
                    <span
                      style={{
                        color: "#181835",
                        fontSize: "12px",
                        marginRight: "-10px",
                      }}
                    >
                      {item.title}
                    </span>
                  </div>
                  <img
                    src={riarr}
                    alt="Arrow"
                    style={{ width: "18px", height: "18px" }}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>



      </div>
     <div
  style={{
    fontFamily: "Epilogue",
    lineHeight: "1.4",
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#004BA8",
    padding: "clamp(30px, 5vw, 60px)",
    color: "#fff",
    gap: "40px",
  }}
>
  {/* Floating Newsletter Image */}
  <div>
    <img
      src={news}
      alt="Newsletter"
      style={{
        width: "200px",
        height: "170px",
        animation: "floatImage 3s ease-in-out infinite",
      }}
    />
  </div>

  <style>
    {`
      @keyframes floatImage {
        0%, 100% { transform: translateY(0); }
        50% { transform: translateY(-10px); }
      }

      @keyframes fadeUp {
        0% {
          opacity: 0;
          transform: translateY(20px);
        }
        100% {
          opacity: 1;
          transform: translateY(0);
        }
      }
    `}
  </style>

  {/* Text + Input Form */}
  <div style={{ animation: "fadeUp 1s ease forwards" }}>
    <h2 style={{ fontSize: "clamp(20px, 2vw, 28px)", marginBottom: "10px", textAlign: "left" }}>
      Subscribe to our Newsletter!
    </h2>

    <p
      style={{
        fontSize: "clamp(14px, 1vw, 16px)",
        marginBottom: "20px",
        maxWidth: "500px",
        textAlign: "left",
      }}
    >
      Stay updated with our latest news, offers, and insights! Subscribe
      for exclusive updates delivered straight to your inbox.
    </p>

    <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: "20px" }}>
      {/* Input with mail icon */}
      <div style={{ position: "relative", flex: "1 1 300px" }}>
        <img
          src={mail}
          alt="Email Icon"
          style={{
            position: "absolute",
            left: "16px",
            top: "50%",
            transform: "translateY(-50%)",
            width: "20px",
            height: "20px",
          }}
        />
        <input
          type="email"
          placeholder="sample@gmail.com"
          style={{
            width: "100%",
            padding: "14px 16px 14px 48px",
            borderRadius: "10px",
            border: "1px solid #9FCAFF",
            outline: "none",
            backgroundColor: "#00377B",
            color: "#fff",
            transition: "box-shadow 0.3s ease",
          }}
          onFocus={(e) => (e.currentTarget.style.boxShadow = "0 0 0 2px #007BFF")}
          onBlur={(e) => (e.currentTarget.style.boxShadow = "none")}
        />
      </div>

      {/* Subscribe Button */}
      <button
        style={{
          padding: "14px 30px",
          borderRadius: "12px",
          border: "none",
          backgroundColor: "#fff",
          color: "#0A3A72",
          marginLeft:"50px",
          fontWeight: "bold",
          cursor: "pointer",
          transition: "background-color 0.3s ease, transform 0.3s ease",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = "#E6F0FF";
          e.currentTarget.style.transform = "translateY(-2px)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = "#fff";
          e.currentTarget.style.transform = "translateY(0)";
        }}
      >
        Subscribe
      </button>
    </div>

    <p style={{ fontSize: "12px", marginTop: "10px" }}>
      *Unsubscribe anytime. We don’t send any spam
    </p>
  </div>
</div>

      <div
  style={{
    fontFamily: "Epilogue",
    lineHeight: "1.4",
    display: "flex",
    justifyContent: "space-between",
    padding: "40px",
    backgroundColor: "#fff",
    flexWrap: "wrap",
    maxWidth: "1200px", // Limit width for larger screens
    margin: "0 auto",   // Center the content horizontally
    boxSizing: "border-box",
  }}
>
  {/* Left Section */}
  <div style={{ maxWidth: "300px", marginBottom: "40px" }}>
    <img
      src={logo}
      alt="Mawalog"
      style={{
        width: "180px",
        height: "50px",
        display: "flex",
        justifyContent: "start",
      }}
    />

    <p
      style={{
        color: "#555",
        fontSize: "14px",
        lineHeight: "1.6",
        textAlign: "start",
        marginBottom: "100px",
      }}
    >
      At Mawalog, we believe in simplifying the complexities of supply
      chain management by offering an integrated platform that combines
      manufacturing, logistics, and warehouse solutions partner with
      optimized logistics and a global network.
    </p>
        <div style={{ display: "flex", gap: "12px", marginTop: "-80px" }}>
      {[insta, face, youtube, link].map((icon, index) => (
        <img
          key={index}
          src={icon}
          alt={`icon-${index}`}
          style={{
            width: "24px",
            height: "24px",
            cursor: "pointer",
            transition: "transform 0.3s ease",
            transformOrigin: "center",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "scale(1.4)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "scale(1)";
          }}
        />
      ))}
    </div>
  </div>

  {/* Learn and Policies Section */}
  <div style={{ display: "flex", gap: "60px", flexWrap: "wrap", justifyContent: "space-between" }}>
    <div>
      <h4 style={{ fontSize: "14px", fontWeight: "bold" }}>Know More</h4>
      {["Opportunities", "Articles", "Our Story", "Help Center"].map((item, index) => (
        <p
          key={index}
          style={{
            margin: "8px 0",
            color: "#555",
            cursor: "pointer",
            textAlign: "start",
            fontSize: "14px",
            transition: "color 0.3s ease, border-bottom 0.3s ease",
            paddingBottom: "2px",
          }}
          onClick={() => {
            if (item === "Our Story") {
              navigate("/about");
            }
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.color = "#3B82F6";
            e.currentTarget.style.borderBottom = "1px solid #3B82F6";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.color = "#555";
            e.currentTarget.style.borderBottom = "none";
          }}
        
        >
          {item}
        </p>
      ))}
    </div>

    <div>
      <h4 style={{ fontSize: "14px", fontWeight: "bold", marginRight: "20px" }}>
        Legal & Policies
      </h4>
      {[
        "Terms and Conditions",
        "Privacy Policy",
        "Cookie Policy",
        "Copyright Policy",
      ].map((item, index) => (
        <p
          key={index}
          style={{
            margin: "8px 0",
            color: "#555",
            cursor: "pointer",
            textAlign: "start",
            fontSize: "14px",
            transition: "color 0.3s ease, border-bottom 0.3s ease",
            paddingBottom: "2px",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.color = "#3B82F6";
            e.currentTarget.style.borderBottom = "1px solid #3B82F6";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.color = "#555";
            e.currentTarget.style.borderBottom = "none";
          }}
          onClick={() => navigate(policyRoutes[item])}
        >
          {item}
        </p>
      ))}
    </div>
  </div>

  {/* Contact and Social Media Section */}
  <div style={{ marginBottom: "40px" }}>
    <h4 style={{ fontSize: "14px", fontWeight: "bold", marginRight: "180px" }}>
      Contact us
    </h4>
    <p style={{ color: "#004BA8", cursor: "pointer", fontSize: "14px", textAlign: "start" }}>
      <img src={email} alt="Email" style={{ width: "14px", height: "14px", marginRight: "8px" }} />
      enquiry@flyjaclogistics.com
    </p>
    <p style={{ fontSize: "14px", textAlign: "start" }}>
      <img src={phone} alt="Phone" style={{ width: "14px", height: "14px", marginRight: "8px" }} />
      <span style={{ color: "#004BA8", cursor: "pointer" }}>603-27700-311</span>{" "}
      (<span style={{ color: "#000" }}>Malaysia</span>)
    </p>
    <p style={{ fontSize: "14px", textAlign: "start" }}>
      <img src={phone} alt="Phone" style={{ width: "14px", height: "14px", marginRight: "8px" }} />
      <span style={{ color: "#004BA8", cursor: "pointer" }}>+971-50-1234567</span>{" "}
      (<span style={{ color: "#000" }}>UAE</span>)
    </p>
    <p style={{ fontSize: "14px", textAlign: "start" }}>
      <img src={phone} alt="Phone" style={{ width: "14px", height: "14px", marginRight: "8px" }} />
      <span style={{ color: "#004BA8", cursor: "pointer" }}>+44 7911 123456</span>{" "}
      (<span style={{ color: "#000" }}>UK</span>)
    </p>
    <p style={{ fontSize: "14px", textAlign: "start" }}>
      <img src={phone} alt="Phone" style={{ width: "14px", height: "14px", marginRight: "8px" }} />
      <span style={{ color: "#004BA8", cursor: "pointer" }}>+91-44- 4856-3345</span>{" "}
      (<span style={{ color: "#000" }}>India</span>)
    </p>
  </div>

  {/* Illustration Section */}
   <div
   className="flex flex-col items-center justify-center p-6 rounded-2xl bg-gradient-to-br from-gray-900 to-purple-700 text-white max-w-sm mx-auto shadow-lg"
   style={{ marginBottom: "40px", position: "relative" }}
 >
   {/* Image container */}
   <div style={{ position: "relative", display: "inline-block" }}>
     {/* Image */}
     <img
       src={trial}
       alt="Illustration"
       style={{ width: "210px", height: "auto", display: "block" }}
     />
 
     {/* Silver Shine Overlay */}
     <div
       style={{
         position: "absolute",
         top: 0,
         left: 0,
         width: "100%",
         height: "100%",
         overflow: "hidden",
         pointerEvents: "none",
         zIndex: 2,
       }}
     >
       <div
         style={{
           position: "absolute",
           top: 0,
           left: "-100%",
           width: "100%",
           height: "100%",
           background:
             "linear-gradient(130deg, transparent 48%, rgba(255,255,255,0.4) 50%, transparent 52%)",
           animation: "shine 3s ease-in-out infinite",
         }}
       ></div>
     </div>
   </div>
 
   {/* Keyframes */}
   <style>
     {`
       @keyframes shine {
         0% {
           left: -100%;
         }
         100% {
           left: 100%;
         }
       }
     `}
   </style>
 </div>
</div>

      <div
        style={{
          fontFamily: "Epilogue",
          lineHeight: "1.4",
          textAlign: "center",
          padding: "20px 0",
          borderTop: "1px solid #ddd",
          fontSize: "14px",
          color: "#333",
        }}
      >
        Copyright © 2024. <strong>MAWALOG</strong>. All Rights Reserved
      </div>
    </div>
  );
};

export default Pricing;
